// extracted by mini-css-extract-plugin
module.exports = {"root":"social-links-module__root___tqleH"};